var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6203 3.33301L22.0269 14.1311L24.7406 7.76744L36.6203 3.33301Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95874 3.33301L17.4223 14.2319L14.8385 7.76743L2.95874 3.33301Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3658 28.3701L27.4829 34.3019L35.7972 36.5911L38.179 28.4998L31.3658 28.3701Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41406 28.4998L3.78133 36.5911L12.0813 34.3019L8.21276 28.3701L1.41406 28.4998Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6337 18.3504L9.32422 21.8346L17.5519 22.2089L17.2777 13.3545L11.6337 18.3504Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9447 18.3496L22.2143 13.2529L22.0266 22.2082L30.2543 21.8338L27.9447 18.3496Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0815 34.3022L17.0614 31.8978L12.7744 28.5576L12.0815 34.3022Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5176 31.8978L27.483 34.3022L26.8046 28.5576L22.5176 31.8978Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.483 34.3028L22.5176 31.8984L22.9217 35.1234L22.8784 36.4912L27.483 34.3028Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0815 34.3028L16.7007 36.4912L16.6718 35.1234L17.0614 31.8984L12.0815 34.3028Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.787 26.4272L12.6587 25.2179L15.5745 23.8789L16.787 26.4272Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.792 26.4272L24.0045 23.8789L26.9348 25.2179L22.792 26.4272Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0813 34.3019L12.8031 28.3701L8.21289 28.4998L12.0813 34.3019Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7756 28.3701L27.483 34.3019L31.3659 28.4998L26.7756 28.3701Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2543 21.834L22.0266 22.2083L22.7916 26.4269L24.0042 23.8784L26.9344 25.2174L30.2543 21.834Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6586 25.2174L15.5744 23.8784L16.7869 26.4269L17.5519 22.2083L9.32422 21.834L12.6586 25.2174Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32446 21.834L12.7744 28.5577L12.6588 25.2174L9.32446 21.834Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9346 25.2174L26.8047 28.5577L30.2546 21.834L26.9346 25.2174Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5525 22.208L16.7874 26.4266L17.7545 31.408L17.971 24.8428L17.5525 22.208Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.027 22.208L21.6228 24.8285L21.8249 31.408L22.792 26.4266L22.027 22.208Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7918 26.4272L21.8247 31.4087L22.5176 31.8982L26.8047 28.558L26.9346 25.2178L22.7918 26.4272Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6587 25.2178L12.7742 28.558L17.0612 31.8982L17.7541 31.4087L16.787 26.4272L12.6587 25.2178Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8787 36.4912L22.9219 35.1234L22.5467 34.8066H17.0327L16.6718 35.1234L16.7007 36.4912L12.0815 34.3027L13.6982 35.6273L16.9749 37.8877H22.5899L25.881 35.6273L27.4832 34.3027L22.8787 36.4912Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5176 31.8976L21.8247 31.4082H17.7542L17.0614 31.8976L16.6716 35.1228L17.0325 34.806H22.5465L22.9219 35.1228L22.5176 31.8976Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2408 14.8366L38.4678 8.87604L36.6201 3.33301L22.5176 13.7712L27.9449 18.3496L35.6097 20.5812L37.2986 18.6088L36.5625 18.076L37.7316 17.0107L36.8367 16.3196L38.0059 15.4269L37.2408 14.8366Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11108 8.87604L2.35246 14.8366L1.55856 15.4269L2.7422 16.3196L1.84725 17.0107L3.01645 18.076L2.28028 18.6088L3.96914 20.5812L11.634 18.3496L17.0613 13.7712L2.95872 3.33301L1.11108 8.87604Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6098 20.5812L27.945 18.3496L30.2546 21.8338L26.8047 28.5574L31.366 28.4998H38.1791L35.6098 20.5812Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6337 18.3496L3.96898 20.5812L1.41406 28.4998H8.21276L12.7741 28.5574L9.32423 21.8338L11.6337 18.3496Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0268 22.2083L22.5176 13.7713L24.7405 7.76758H14.8384L17.0613 13.7713L17.552 22.2083L17.7397 24.8574L17.7542 31.4083H21.8247L21.8392 24.8574L22.0268 22.2083Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamask);
export default __webpack_public_path__ + "static/media/icon-metamask.a8754af75fb49d3c355acac23226cda1.svg";
export { ForwardRef as ReactComponent };